import hasClass from './hasClass';
import addClass from './addClass';
import removeClass from './removeClass';
import notExisty from './notExisty';

export default function toggleClass(el, className, state) {
   if ( notExisty(state) ) {
      state = !hasClass(el, className);
   }

   if (state) {
      addClass(el, className);
   } else {
      removeClass(el, className);
   }
}
